import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import IncrementInput from '../../../../Common/incrementInput'
import Validator from '../../../../Common/validator'
import { connect } from 'react-redux';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import {
  updateActivityName,
  updateActivityHours,
  updateActivityTouched,
  updatePredefinedActivity,
  addActivity
} from './actions'

class Activities extends Component{
  addActivity = (index) => {
    if(index===this.props.activities.length-1){
      this.props.dispatch(addActivity());
    }
  };
  isContainerActive = () => {
    const { activities } = this.props;
    for (let i = 0; i < activities.length; i++) {
      if(activities[i].name || activities[i].hours)
        return true
    }
    return false
  };
  render()  {
    const { activities, dispatch, predefinedActivities } = this.props;

    let predefinedActivitiesNodes = [];
    predefinedActivities.forEach((activity, index) => {
        predefinedActivitiesNodes.push(
          <option
            key={index}
            value={activity}>
            {activity}
          </option>
        )
      })


    let isAllValid = true;
    let activityNodes = activities.map((activity, index) => {
      let isNameInvalid = (activity.hours && activity.nameTouched && !activity.name && activity.activity === 'Diverse');
      if(isNameInvalid)
        isAllValid = false

      return (
        <div key={index} className="row" style={styles.activityContainer}>
          <div className="col-xs-3" style={styles.noPadding}>
              <select
                value={activity.activity}
                style={styles.select}
                onChange={(evt) => {
                  if(evt.target.value)
                  {
                    this.addActivity(index);
                  }
                  dispatch(updatePredefinedActivity(evt.target.value, index))
                }}>
                  {predefinedActivitiesNodes}
              </select>
          </div>
          <div style={styles.firstColumn} className="col-xs-6">
            <Validator isValid={!isNameInvalid}>
              <input
                type="text"
                placeholder={isNameInvalid ? "Skal udfyldes hvis der er afsat timer" : "..."}
                onChange={(evt) =>{
                  dispatch(updateActivityName(evt.target.value, index))
                  this.addActivity(index);
                }}
                value={activity.name}
                onBlur={ () =>
                  dispatch(updateActivityTouched('nameTouched', index))
                }
                style={styles.input}/>
            </Validator>
          </div>
          <div className="col-xs-3">
            <IncrementInput
              minValue={0}
              maxValue={150}
              interval={0.5}
              defaultValue={activity.hours}
              onChange={(val) => {
                dispatch(updateActivityHours(val, index))
              }}
            />
          </div>
        </div>
      )
    })

    return (
      <div style={styles.outerContainer}>
        <div className="row" style={[styles.container, this.isContainerActive() && styles.containerActive, !isAllValid && styles.containerError]}>
          <div style={styles.heading}>
            Aktiviteter
          </div>
          <div>
            <div style={[styles.colHeading, styles.firstColumn, styles.noPadding]} className="col-xs-3">Standard</div>
            <div style={[styles.colHeading, styles.firstColumn]} className="col-xs-6">Navn/ Beskrivelse</div>
            <div style={styles.colHeading} className="col-xs-3">Timer</div>
          </div>
          {activityNodes}
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    margin: '0 0 12px 0',
    paddingRight: '12px'
  },
  container: {
    backgroundColor: greyScaleColors.greyLighter,
    padding: '2px 0 8px 6px',
    margin: '0',
    borderLeft: '2px solid ' + semanticColors.mainBackground
  },
  containerActive: {
    borderLeft: '2px solid ' + semanticColors.info
  },
  containerError: {
    borderLeft: '2px solid ' + semanticColors.danger
  },
  firstColumn: {
    textAlign: 'left'
  },
  heading: {
    marginBottom: '5px'
  },
  colHeading:{
    fontSize: '12px',
    paddingBottom: '4px',
    textAlign: 'center'
  },
  activityContainer: {
    margin: '0 0 6px 0'
  },
  select: {
    '-webkit-appearance': 'none',
    '-moz-appearance':    'none',
    '-webkit-border-radius': '0px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    backgroundColor: 'white',
    border: 'none',    
    cursor: 'pointer',
    width:' 100%',
    height: '35px',
    padding: '5px'
  },
  noPadding:{
    padding: '0px'
  },
  input: {
    '-webkit-appearance': 'none',  
    border: 'none',
    display: 'block',
  }
}


const selectProps = state => {
  return {
    ...state.dailyReportActivitiesReducer,
    predefinedActivities: state.dailyReportReducer.predefinedActivities
  };
}
  Activities.propTypes = {
    activities: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      hours: PropTypes.number,
      nameTouched: PropTypes.bool
    })),
    predefinedActivities: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
  };
export default connect(selectProps)(Radium(Activities));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Activities/index.jsx